import { render, staticRenderFns } from "./createInventory.vue?vue&type=template&id=47b0f0aa&"
import script from "./createInventory.vue?vue&type=script&lang=js&"
export * from "./createInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports